import axios from 'axios'
import { UrlBase } from './config'

const journey = {}

journey.newJourney = async (token, companyId, appId, data) => {
  const { name, dependsOn, extraData, createMenu, setOnRegister, mainColor, template } = data
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        name,
        dependsOn,
        extraData,
        createMenu,
        setOnRegister,
        mainColor,
        template
      },
      method: 'POST',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

journey.getJourneys = async (token, companyId, appId, pagination, search) => {
  const { page = 1, itemsPerPage = 100, sortBy = '', descending = '' } = pagination
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page,
        limit: itemsPerPage,
        sortBy,
        descending,
        search: search || ''
      },
      method: 'GET',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

journey.getJourney = async (token, companyId, appId, journeyId) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'GET',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys/${journeyId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

journey.deleteDependsOn = async (token, companyId, appId, journeyId, dependsOn) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        dependsOn
      },
      method: 'DELETE',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys/${journeyId}/remove/dependencies`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

journey.deleteJourney = async (token, companyId, appId, journeyId) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'DELETE',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys/${journeyId}`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

journey.updateDependsOn = async (token, companyId, appId, journeyId, dependsOn) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        dependsOn,
        replaceVal: true
      },
      method: 'PUT',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys/${journeyId}/add/dependencies`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

journey.updateJourney = async (token, companyId, appId, journeyId, data) => {
  const { name, dependsOn, extradata, createMenu, setOnRegister, mainColor, template, replaceVal } = data
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        name,
        dependsOn,
        extradata,
        createMenu,
        setOnRegister,
        mainColor,
        template,
        replaceVal
      },
      method: 'PUT',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/journeys/${journeyId}`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}
export default journey
